import { useEffect } from 'react';

export interface PhoneValue {
  code: string;
  number: string;
}

export const useSyncPhoneValue = (
  value: PhoneValue,
  phoneValue: PhoneValue,
  onChange: (newValue: PhoneValue) => void
) => {
  useEffect(() => {
    if (phoneValue.code && value.code !== phoneValue.code && !value.number) {
      onChange(phoneValue);
    }
  }, [phoneValue, value.code, value.number, onChange]);
};
